import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Header from '../../../components/Header';
import { Box, FormControl, Grid, IconButton, MenuItem, Select, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import { getInstallerInEle } from '../../../redux/slice/electrician.slice';

function Electrician() {
  const getuserId = localStorage.getItem("id");
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width:500px)');
  const navigate = useNavigate();
  const AssignInstaller = useSelector(state => state.electrician.assign) || [];
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    dispatch(getInstallerInEle())
  }, [dispatch])

  useEffect(() => {
    dispatch(getInstallerInEle());
}, []);


  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleEdit = (assignId, liasoningId, electricianId) => {
    navigate('/admin/add-electrician', { state: { assignId, liasoningId, electricianId } })
  }

  const [selectedStatus, setSelectedStatus] = useState("0");
  const [searchQuery, setSearchQuery] = useState("");

  const getDateRange = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();
    const currentDay = currentDate.getDate();
    let startDate, endDate;
    if (currentDay >= 26) {
      startDate = new Date(currentYear, currentMonth, 26);
      endDate = new Date(currentYear, currentMonth + 1, 25);
    } else {
      startDate = new Date(currentYear, currentMonth - 1, 26);
      endDate = new Date(currentYear, currentMonth, 25);
    }
    return {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate)
    };
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const filteredData = useMemo(() => {
    if (!Array.isArray(AssignInstaller)) {
      return [];
    }
    let filtered = AssignInstaller;
    if (selectedStatus === "Work Pending") {
      filtered = AssignInstaller.filter(item => {
        const matchingFabricator = item.eledata[0];
        return item.Electrician &&
          (!matchingFabricator?.electricianDetails ||
            !matchingFabricator.electricianDetails.some(detail =>
              detail.electricianSubCatogory &&
              detail.electricianProductName &&
              detail.electricianQty
            )
          );
      });
    } else if (selectedStatus === "Work Complete") {
      filtered = AssignInstaller.filter(item => {
        const matchingFabricator = item.eledata[0];
        return item.Electrician &&
          matchingFabricator?.electricianDetails?.length > 0 &&
          matchingFabricator?.electricianDetails?.every(detail =>
            detail.electricianSubCatogory &&
            detail.electricianProductName &&
            detail.electricianQty
          )
          &&
          matchingFabricator?.TotalAmount === "0.00"
      });
    } else if (selectedStatus === "Payment Pending") {
      filtered = AssignInstaller.filter(item => {
        const matchingFabricator = item.eledata[0];
        return item.Electrician &&
          matchingFabricator?.electricianDetails?.some(detail =>
            detail.electricianSubCatogory &&
            detail.electricianProductName &&
            detail.electricianQty
          ) &&
          matchingFabricator?.TotalAmount === "0.00"
      });
    } else if (selectedStatus === "Payment Processing") {
      filtered = AssignInstaller.filter(item => {
        const matchingFabricator = item.eledata[0];
        return item.Electrician &&
          matchingFabricator?.TotalAmount > 0 &&
          matchingFabricator?.requestStatus !== "Approved";
      });
    }
    else if (selectedStatus === "Send to Account Department") {
      filtered = AssignInstaller.filter(item => {
        const matchingFabricator = item.eledata[0];
        const fabricatorId = item.electricianData?.[0]?._id;
        return item.Electrician &&
          matchingFabricator?.requestStatus === "Approved" &&
          (!item.electricianPaymentData ||
            !item.electricianPaymentData.some(payment =>
              payment.type === "electrician" &&
              payment.userId === fabricatorId &&
              payment.status === "Complete" &&
              payment.fileDetails?.some(detail =>
                detail.fileNo === item.marketData[0]?.fillNo &&
                detail.PaymentTotal > 0
              )
            ));
      });
    }
    else if (selectedStatus === "Payment Received") {
      filtered = AssignInstaller.filter(item => {
        const matchingFabricator = item.eledata[0];
        const fabricatorId = item.electricianData?.[0]?._id;

        console.log("matchingFabricatormatchingFabricator", matchingFabricator);
        
        return item.Electrician &&
        matchingFabricator?.requestStatus === "Complete" &&
          item.electricianPaymentData?.some(payment => payment.type === "electrician" &&
            payment.userId === fabricatorId &&
            payment.fileDetails?.some(detail =>
              detail.fileNo === item.marketData[0]?.fillNo &&
              detail.PaymentTotal > 0
            ) &&
            payment.status === "Complete"
          );
      });
    }

    if (searchQuery) {
      filtered = filtered.filter(item => {
        const marketData = item.marketData[0];
        const userData = item.marketuserData[0];
        const ModuleData = item.ModuleData[0];
        const inverterData = item.inverterData[0];

        return (
          marketData.fillNo?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          marketData?.ConsumerName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          marketData?.Address?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          marketData?.City_Village?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          marketData?.PhoneNumber?.toString().includes(searchQuery) ||
          marketData?.SystemSizeKw?.toString().includes(searchQuery) ||
          userData?.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          ModuleData?.productName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          inverterData?.productName?.toLowerCase().includes(searchQuery.toLowerCase())
        );
      });
    }
    return filtered;
  }, [selectedStatus, AssignInstaller, searchQuery]);

  const calculateStatusCounts = () => {
    const workPendingCount = AssignInstaller?.filter(item => {
      const matchingFabricator = item.eledata[0];
      return item.Electrician &&
        (!matchingFabricator?.electricianDetails ||
          !matchingFabricator.electricianDetails.some(detail =>
            detail.electricianSubCatogory &&
            detail.electricianProductName &&
            detail.electricianQty
          )
        );
    }
    ).length;

    const workCompleteCount = AssignInstaller.filter(item => {
      const matchingFabricator = item.eledata[0];
      return item.Electrician &&
        matchingFabricator?.electricianDetails?.every(detail =>
          detail.electricianSubCatogory &&
          detail.electricianProductName &&
          detail.electricianQty
        ) &&
        matchingFabricator?.TotalAmount === "0.00"
    }).length;

    const pendingPaymentCount = AssignInstaller.filter(item => {
      const matchingFabricator = item.eledata[0];
      return item.Electrician &&
        matchingFabricator?.electricianDetails?.some(detail =>
          detail.electricianSubCatogory &&
          detail.electricianProductName &&
          detail.electricianQty
        ) &&
        matchingFabricator?.TotalAmount === "0.00"
    }).length;

    const paymentProcessingCount = AssignInstaller.filter(item => {
      const matchingFabricator = item.eledata[0];
      return item.Electrician &&
        matchingFabricator?.TotalAmount > 0 &&
        matchingFabricator?.requestStatus !== "Approved"
    }).length;

    const approvedCount = AssignInstaller.filter(item => {
      const matchingFabricator = item.eledata[0];
      const fabricatorId = item.electricianData?.[0]?._id;
      return item.Electrician &&
        matchingFabricator?.requestStatus === "Approved" &&
        (!item.electricianPaymentData ||
          !item.electricianPaymentData.some(payment =>
            payment.type === "electrician" &&
            payment.userId === fabricatorId &&
            payment.status === "Complete" &&
            payment.fileDetails?.some(detail =>
              detail.fileNo === item.marketData[0]?.fillNo &&
              detail.PaymentTotal > 0
            )
          ));
    }).length;

    const receivedCount = AssignInstaller.filter(item => {
      const fabricatorId = item.electricianData?.[0]?._id;

      return item.Electrician &&
        item.electricianPaymentData?.some(payment => payment.type === "electrician" &&
          payment.userId === fabricatorId &&
          payment.fileDetails?.some(detail =>
            detail.fileNo === item.marketData[0]?.fillNo &&
            detail.PaymentTotal > 0
          ) &&
          payment.status === "Complete"
        );
    }).length;

    return {
      workPendingCount,
      workCompleteCount,
      pendingPaymentCount,
      paymentProcessingCount,
      approvedCount,
      receivedCount
    };
  };

  const {
    workPendingCount,
    workCompleteCount,
    pendingPaymentCount,
    paymentProcessingCount,
    approvedCount,
    receivedCount
  } = calculateStatusCounts();

  console.log("filteredData", filteredData)

  return (
    <Box m="2px" sx={{ overflow: isMobile ? 'auto' : 'hidden' }}>
      <Header
        title="ELECTRICIAN"
        subtitle="Manage Your Electrician Here"

      />
      <Box>
        <FormControl size="small" sx={{ display: { xs: 'block', md: 'inline-flex', paddingRight: "10px" } }}>
          <Select
            value={selectedStatus}
            onChange={(event) => {
              setSelectedStatus(event.target.value);
            }}
            sx={{
              minWidth: '100%',
              [theme.breakpoints.up('sm')]: {
                minWidth: '200px',
                marginLeft: '10px',
              },
              [theme.breakpoints.down('sm')]: {
                minWidth: '200px',
                marginLeft: '10px',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#566585',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#566585',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#566585',
                borderWidth: '2px',
              },
            }}
          >
            <MenuItem value="0">Status </MenuItem>
            <MenuItem value="Work Pending">
              Work Pending {workPendingCount > 0 ? `(${workPendingCount})` : ''}
            </MenuItem>
            <MenuItem value="Work Complete">
              Work Complete {workCompleteCount > 0 ? `(${workCompleteCount})` : ''}
            </MenuItem>
            <MenuItem value="Payment Pending">Payment Pending
              {pendingPaymentCount > 0 ? `(${pendingPaymentCount})` : ''}
            </MenuItem>
            <MenuItem value="Payment Processing">Payment Processing
              {paymentProcessingCount > 0 ? `(${paymentProcessingCount})` : ''}
            </MenuItem>
            <MenuItem value="Send to Account Department">Send to Account Department
              {approvedCount > 0 ? `(${approvedCount})` : ''}
            </MenuItem>
            <MenuItem value="Payment Received">Payment Received
              {receivedCount > 0 ? `(${receivedCount})` : ''}
            </MenuItem>
          </Select>
        </FormControl>

        <TextField
          size="small"
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          sx={{
            minWidth: { xs: '200px', md: '200px' },
            marginTop: { xs: '10px', md: '0' },
            marginLeft: { xs: '10px', md: '10px' },
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#566585',
              },
              '&:hover fieldset': {
                borderColor: '#566585',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#566585',
                borderWidth: '2px',
              }
            }
          }}
        />
      </Box>

      {
        filteredData?.filter((a) => a?.Electrician)?.length === 0 ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
            <Typography variant="h4" align="center" color="textSecondary">No data available</Typography>
          </Box>
        ) : (
          <>
            {
              filteredData.filter((a) => a.Electrician).map((v) => {
                const electricianId = v.eledata[0];
                return <div key={v._id}>
                  <Box className="padding_box" sx={{
                    m: 3, ml: 0, mr: 0, p: 3, borderRadius: 2, bgcolor: theme.palette.mode === 'dark' ? '#293040' : "#E5F1FD", color: theme.palette.mode === 'dark' ? 'white' : "black",

                  }} key={v._id}
                  >
                    <Grid container justifyContent="space-between" xs={12} sm={12} md={12} item>
                      {!isMobile && (
                        <>
                          <Grid container spacing={2}>
                            {/* Column 1 */}
                            <Grid item xs={12} md={6}>
                              {[
                                { label: 'File No', value: v.marketData[0]?.fillNo },
                                { label: 'Consumer Name', value: v.marketData[0]?.ConsumerName },
                                { label: 'Address', value: v.marketData[0]?.Address },
                                { label: 'City', value: v.marketData[0]?.City_Village },
                                { label: 'Contact No', value: v.marketData[0]?.PhoneNumber },
                                { label: 'System Size', value: v.marketData[0]?.SystemSizeKw },
                                { label: 'Dealer', value: v.marketuserData.map(a => a?.name).join(', ') },
                                { label: 'Solar PV Module', value: v.ModuleData?.map((a) => a.productName).join(', ') },
                                { label: 'Solar Grid Tie Inverter', value: v.inverterData?.map((a) => a.productName).join(', ') },
                              ].map((item, i) => (
                                <Grid container key={i}>
                                  <Grid item xs={5} sx={{ fontWeight: '600' }}>{item.label}</Grid>
                                  <Grid item xs={7}>: &nbsp;{item.value}</Grid>
                                </Grid>
                              ))}
                            </Grid>

                            {/* Column 2 */}
                            <Grid item xs={12} md={4}>
                              {[
                                { label: 'Fabrication', value: v.fabricatorData.map((a) => a.name).join(', ') },
                                { label: 'Electrician', value: v.electricianData.map((a) => a.name).join(', ') },
                                { label: 'Technician', value: v.technicianData.map((a) => a.name).join(', ') },
                              ].map((item, i) => (
                                <Grid container key={i}>
                                  <Grid item xs={5} sx={{ fontWeight: '600' }}>{item.label}</Grid>
                                  <Grid item xs={7}>: &nbsp;{item.value}</Grid>
                                </Grid>
                              ))}
                            </Grid>

                            {/* Column 3 — edit button aligned at bottom right */}
                            <Grid item xs={12} md={2} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start' }}>
                              <Box sx={{ bgcolor: v.eledata.some(x1 => x1.requestStatus === "Approved" || x1.requestStatus === "Complete") ? 'gray' : '#134670', borderRadius: '50%', p: 0.5 }}>
                                <IconButton aria-label="edit" style={{ color: "white" }}
                                  disabled={v.eledata.some(x1 => x1.requestStatus === "Approved" || x1.requestStatus === "Complete") ? true : false}
                                  onClick={() => handleEdit(v._id, v.liasoningId, electricianId?._id)}
                                >
                                  <EditIcon />
                                </IconButton>
                              </Box>
                            </Grid>
                          </Grid>
                        </>
                      )}
                      {isMobile ? (
                        <>
                          <Grid container spacing={2}>
                            {/* Column 1 */}
                            <Grid item xs={12} md={6}>
                              {[
                                { label: 'File No', value: v.marketData[0]?.fillNo },
                                { label: 'Consumer Name', value: v.marketData[0]?.ConsumerName },
                                { label: 'Address', value: v.marketData[0]?.Address },
                                { label: 'City', value: v.marketData[0]?.City_Village },
                                { label: 'Contact No', value: v.marketData[0]?.PhoneNumber },
                                { label: 'System Size', value: v.marketData[0]?.SystemSizeKw },
                                { label: 'Dealer', value: v.marketuserData.map(a => a?.name).join(', ') },
                                { label: 'Solar PV Module', value: v.ModuleData?.map((a) => a.productName).join(', ') },
                                { label: 'Solar Grid Tie Inverter', value: v.inverterData?.map((a) => a.productName).join(', ') },
                              ].map((item, i) => (
                                <Grid container key={i}>
                                  <Grid item xs={5} sx={{ fontWeight: '600' }}>{item.label}</Grid>
                                  <Grid item xs={7}>: &nbsp;{item.value}</Grid>
                                </Grid>
                              ))}
                            </Grid>

                            {/* Column 2 */}
                            <Grid item xs={12} md={4}>
                              {[
                                { label: 'Fabrication', value: v.fabricatorData.map((a) => a.name).join(', ') },
                                { label: 'Electrician', value: v.electricianData.map((a) => a.name).join(', ') },
                                { label: 'Technician', value: v.technicianData.map((a) => a.name).join(', ') },
                              ].map((item, i) => (
                                <Grid container key={i}>
                                  <Grid item xs={5} sx={{ fontWeight: '600' }}>{item.label}</Grid>
                                  <Grid item xs={7}>: &nbsp;{item.value}</Grid>
                                </Grid>
                              ))}
                            </Grid>

                            {/* Column 3 — edit button aligned at bottom right */}
                            <Grid item xs={12} md={2} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start' }}>
                              <Box sx={{ bgcolor: v.eledata.some(x1 => x1.requestStatus === "Approved" || x1.requestStatus === "Complete") ? 'gray' : '#134670', borderRadius: '50%', p: 0.5 }}>
                                <IconButton aria-label="edit" style={{ color: "white" }}
                                  disabled={v.eledata.some(x1 => x1.requestStatus === "Approved" || x1.requestStatus === "Complete") ? true : false}
                                  onClick={() => handleEdit(v._id, v.liasoningId, electricianId?._id)}
                                >
                                  <EditIcon />
                                </IconButton>
                              </Box>
                            </Grid>
                          </Grid>
                        </>
                      ) : (
                        <>
                        </>
                      )}
                    </Grid>
                  </Box>
                </div>
              })
            }
          </>
        )
      }
    </Box>
  )
}

export default Electrician;